"use strict";

var _awesomePhonenumber = require("awesome-phonenumber");

const Validator = require('validator');
/** 
 * @function isEmail verifies that a string is an email address
 * @param {string} email email to be validated
 */


exports.isEmail = v => {
  try {
    return v == null ? false : Validator.isEmail(v);
  } catch (err) {
    return false;
  }
};
/**
 * @function isPhone verifies that a string is a phone number
 * @param {string} phone phone number to be validated
 */


exports.isPhone = v => {
  try {
    if (v == null || typeof v !== 'string') {
      return false;
    }

    if (v.trim().length < 10) {
      return false;
    } // If country code is provided, use it, otherwise default to US


    const pn = v.trim().startsWith('+') ? (0, _awesomePhonenumber.parsePhoneNumber)(v) : (0, _awesomePhonenumber.parsePhoneNumber)(v, {
      regionCode: 'US'
    });
    return pn.valid;
  } catch (err) {}

  return false;
};
/**
 * @function optional Converts a validator function into optional by allowing v == null or an empty string to return true
 * @param {function} validator validator to be changed to allow null
 **/


exports.optional = validator => {
  return v => {
    if (v == null || typeof v === 'string' && v.trim().length === 0) {
      return true;
    }

    return validator(v);
  };
};

exports.required = v => {
  if (v == null || typeof v === 'string' && v.trim().length === 0) {
    return false;
  }

  return true;
};